import React, { type FC } from 'react';

import { Box, xcss } from '@atlaskit/primitives';

export type AnalyticsTableCellSize = AnalyticsTableCellSizeText | AnalyticsTableCellSizeNumber;

type AnalyticsTableCellSizeText =
	| 'full'
	| 'xxlarge'
	| 'xlarge'
	| 'large'
	| 'medium'
	| 'small'
	| 'xsmall';

type AnalyticsTableCellSizeNumber = '100' | '70' | '60' | '50' | '40' | '30' | '20' | '10';

const cellBaseStyle = xcss({
	paddingTop: 'space.050',
	paddingBottom: 'space.050',
	paddingLeft: 'space.100',
	paddingRight: 'space.100',
});

const startAlignStyle = xcss({ textAlign: 'start' });

const width100CellStyle = xcss({ width: '100%' });
const width70CellStyle = xcss({ width: '70%' });
const width60CellStyle = xcss({ width: '60%' });
const width50CellStyle = xcss({ width: '50%' });
const width40CellStyle = xcss({ width: '40%' });
const width30CellStyle = xcss({ width: '30%' });
const width20CellStyle = xcss({ width: '20%' });
const width10CellStyle = xcss({ width: '10%' });
const sortableCellStyle = xcss({ paddingLeft: 'space.250' });

export const TableCell: FC<{
	as?: 'th' | 'td';
	size?: AnalyticsTableCellSize;
	isSortable?: boolean;
	children?: React.ReactNode;
}> = ({ children, size, isSortable, as, ...props }) => (
	<Box
		as={as}
		xcss={[
			cellBaseStyle,
			as === 'th' && startAlignStyle,
			(size === '100' || size === 'full') && width100CellStyle,
			(size === '70' || size === 'xxlarge') && width70CellStyle,
			size === '60' && width60CellStyle,
			(size === '50' || size === 'xlarge') && width50CellStyle,
			(size === '40' || size === 'large') && width40CellStyle,
			(size === '30' || size === 'medium') && width30CellStyle,
			(size === '20' || size === 'small') && width20CellStyle,
			(size === '10' || size === 'xsmall') && width10CellStyle,
			Boolean(isSortable) && sortableCellStyle,
		]}
		{...props}
	>
		{children}
	</Box>
);
